import React, { useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import Logo from '../../atoms/Logo'
import {
  MenuHamburger,
  NavEmployer,
  NavLanguageChanger,
  NavUser,
} from '../../molecules'
import styles from './styles.module.scss'
import Avatar from '@/components/atoms/Avatar'
import useOuterClick from '@/components/hooks/useOuterClick'
import { useMe } from '@/context/meContext'

const HeaderBarEmployer = () => {
  const [menuVisible, setMenuVisible] = useState<boolean>(false)
  const innerRef = useOuterClick((e: React.MouseEvent) => {
    setMenuVisible(false)
  })

  const { me } = useMe()
  const { t, lang } = useTranslation()
  const router = useRouter()

  const handleMenuTrigger = (e: React.MouseEvent) => {
    setMenuVisible(!menuVisible)
  }

  const sessionLink = (user: any) => {
    let url: string
    switch (user.__typename) {
      case 'Admin':
        url = '/admin'
        break
      case 'Candidate':
        url = '/account'
        break
      case 'User':
        url = '/dashboard'
        break
      default:
        url = '/account'
        break
    }

    return url
  }

  return (
    <header
      ref={innerRef}
      className={`${styles['header-primary']} ${
        menuVisible ? styles['header-primary__expanded'] : ''
      }`}
    >
      <div className='lg:container'>
        <div className={styles.menu__containerWrapper}>
          <Logo className='mr-auto' />

          <div
            className={`${styles.menu__wrapper} ${
              menuVisible ? styles['menu--visible'] : ''
            }`}
          >
            <NavEmployer setMenuVisible={setMenuVisible} />
          </div>

          <a href='/auth/sign_up' className={`${styles.menu__buyButton}`}>
            {t('common:register')}
          </a>
          {(!me || me?.__typename !== 'User') && (
            <a href='/' className={`${styles.menu__forEmployeeButton}`}>
              {t('common:for_employee')}
            </a>
          )}
          {!me ? (
            <NavUser className={`lg:ml-0 ${menuVisible ? '' : ''}`} />
          ) : (
            <a href={sessionLink(me)} rel='nofollow' title=''>
              <Avatar url={me.avatar?.url} size='normal' remote />
            </a>
          )}
          {/* eslint-disable-next-line react/button-has-type */}
          <MenuHamburger
            menuVisible={menuVisible}
            handleMenuTrigger={handleMenuTrigger}
          />

          <div className={styles.menu__langChangerWrapper}>
            <NavLanguageChanger />
          </div>
        </div>
      </div>
    </header>
  )
}

export default HeaderBarEmployer
